<template>
    <div class="gallery-holder">
        <div class="gallery-title">
                Gallery
        </div>
        <div class="gallery">
            <div class="column" v-for="images in allImages" v-bind:key="images.id">
                <hover-zoom v-for="img in images.arr" v-bind:key="img.id" :src="img.url" alt="" :canClick="true" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Gallery',
        data() {
            return {
                firebase: null,
                allImages: null,
                galleryImgWidth: 0
            }
        },
        mounted() {
            this.firebase = this.$store.getters.firebase
            this.getFiles()
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        methods: {
            handleResize() {
                this.galleryImgWidth = (window.innerWidth - (window.innerWidth * 0.20)) * 0.20;
            },
            chunkArray(myArray, chunk_size) {
                var tempArray = [];
                for (var i = 0; i < chunk_size; i++) {
                    tempArray.push({
                        arr: [],
                        id: i
                    });
                }

                var tmpI = 0;
                for (var j = 0; j < myArray.length; j++) {
                    if(tmpI > tempArray.length - 1) {
                        tmpI = 0;
                    }
                    
                    tempArray[tmpI].arr.push(myArray[j])
                    tmpI++;
                }

                return tempArray;
            },
            getFiles() {
                const databaseRef = this.firebase.database().ref('/images');

                const thisVar = this

                databaseRef.once('value', (snapshot) => {
                    const images = snapshot.val()
                    thisVar.allImages = typeof images === "object" && Object.keys(images).map((key) => {
                        return {
                            id: key,
                            ...images[key]
                        }
                    }).filter(i => i.category === null || i.category === undefined);

                    thisVar.allImages = this.chunkArray(thisVar.allImages, 4);
                })
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>